import {UncompleteOrderComponent} from "./uncomplete-order.component";

export default UncompleteOrderComponent
